export default {
  common: {
    search: 'Search',
    selected: 'Selected',
  },
  actions: {
    clear: 'Clear',
  },
};
